import { use } from "react"

import { GeometryPickerContext } from "./GeometryPickerContext/context"
import { ImageOverlayPickerContext } from "./ImageOverlayPickerContext/context"
import { LocationPickerContext } from "./LocationPickerContext/context"
import { PolygonPickerContext } from "./PolygonPickerContext/context"
import { SelectedAssetsContext } from "./SelectedAssetsContext/context"
import { TextConfirmationDialogContext } from "./TextConfirmationDialogContext/context"
import { ViewportSizeContext } from "./ViewportSizeContext/context"

export const useSelectedAssets = () => use(SelectedAssetsContext)

export const useViewportSize = () => use(ViewportSizeContext)

export const useLocationPicker = () => use(LocationPickerContext)

export const useTextConfirmationDialog = () => use(TextConfirmationDialogContext)

export const useGeometryPicker = () => use(GeometryPickerContext)

export const usePolygonPicker = () => use(PolygonPickerContext)

export const useImageOverlayPicker = () => use(ImageOverlayPickerContext)
